import netsForgotUsername from './nets-forgot-username';
import moduleConfig from './module-config';

export default angular
  .module('app.forgotUsername', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsForgotUsername', netsForgotUsername);
